<template>
  <dl class="flex flex-wrap justify-center gap-4 md:gap-8">
    <div
      v-for="figure in BRAND_KEY_FIGURES"
      :key="figure.label"
      class="bg-primary-50 text-primary-950 flex items-center gap-3 rounded-lg px-8 py-6"
    >
      <dd class="text-4xl font-extrabold">
        {{ figure.value }}
      </dd>
      <dt class="text-lg" v-html="figure.label" />
    </div>
  </dl>
</template>

<script lang="ts" setup>
import { BRAND_KEY_FIGURES } from "~/business-areas/brand/brand-key-figures";
</script>
